
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { Component } from "react";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import FormServices from "../../Services/FormServices";
import { all } from "axios";

export interface IInterestDetails {
    id: string,
    interestCategory: string,
    firstQuarterRate: string,
    secondQuarterRate: string,
    thirdQuarterRate: string,
    fourthQuarterRate: string,
    taxYear: string
}

interface IInterestDetailsState {
    allTaxYears: string[],
    selectedYear: string,
    firstQtr: string,
    secondQtr: string,
    thirdQtr: string,
    fouthQtr: string,
    selectedID: string,
    accessToken: string

}


class IRSInterestDetails extends Component<{}, IInterestDetailsState> {
    constructor(_props: any) {
        super(_props);
        this.state = {
            allTaxYears: [],
            selectedYear: '',
            firstQtr: '',
            secondQtr: '',
            thirdQtr: '',
            fouthQtr: '',
            selectedID: '',
            accessToken: '',

        }
    }
    allDetails: IInterestDetails[] = [];
    
    async componentDidMount() {
        const accesstoken = await loadFromLocalStorage('accessToken');
        if (accesstoken) {
            this.setState({ accessToken: accesstoken.toString() }, () => {
                this.getInterestDetails();
            });
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    }

    getInterestDetails() {
        FormServices.getIrsInterestDetails(this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then((resp: IInterestDetails[]) => {
                    this.allDetails = resp;
                    let allTaxYears = resp.map(x => x.taxYear);
                    let selectedTax = resp.filter(x => x.taxYear == new Date().getFullYear().toString())[0];
                    this.setState({
                        allTaxYears: allTaxYears
                    })
                })
            }
        })
    }


    selectHandler(event: any) {
        let selectedVal = this.allDetails.filter(x => x.taxYear === event.target.value)[0];
        this.setState({
            selectedID: selectedVal.id, firstQtr: selectedVal.firstQuarterRate,
            secondQtr: selectedVal.secondQuarterRate, thirdQtr: selectedVal.thirdQuarterRate, fouthQtr: selectedVal.fourthQuarterRate, selectedYear: selectedVal.taxYear
        })
    }


    render() {
        return (<div className="expense-container">
            <h2> Update IRS Interest Details</h2>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%'
            }}>
                <FormControl id='et' sx={{ m: 1, width: '50%' }} >
                    <InputLabel id="demo-simple-select-standard-label">Tax Years</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        label="Expense Type"
                        onChange={(event) => this.selectHandler(event)}>
                       

                        {this.state.allTaxYears.map(x => {
                            return (
                                <MenuItem value={x}>{x}</MenuItem>
                            );
                        })}

                    </Select>
                </FormControl>
                <FormControl id='et' sx={{ m: 1, width: '50%' }} >
                    <TextField id="outlined-basic" label="Interest of First Quarter" variant="outlined"
                        value={this.state.firstQtr}
                        onInput={(event) => console.log(event, "onePersonAmnt")}
                    />
                </FormControl>

            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%'
            }}>
                <FormControl id='et' sx={{ m: 1, width: '50%' }} >
                    <TextField id="outlined-basic" label="Interest of Second Quarter" variant="outlined"
                        value={this.state.secondQtr}
                        onInput={(event) => console.log(event, "onePersonAmnt")}
                    />
                </FormControl>
                <FormControl id='et' sx={{ m: 1, width: '50%' }} >
                    <TextField id="outlined-basic" label="Interest of Third Quarter" variant="outlined"
                        value={this.state.thirdQtr}
                        onInput={(event) => console.log(event, "onePersonAmnt")}
                    />
                </FormControl>

            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%'
            }}>
                <FormControl id='et' sx={{ m: 1, width: '50%', margin: '10px auto' }} >
                    <TextField id="outlined-basic" label="Interest of Fourth Quarter" variant="outlined"
                        value={this.state.fouthQtr}
                        onInput={(event) => console.log(event, "onePersonAmnt")}
                    />
                </FormControl>
                {/* <FormControl id='et' sx={{ m: 1, width: '50%' }} >
                    
                </FormControl> */}
            </div>
            <button className="expense-Action-btn" onClick={(event) => console.log()} ><p><b>Update Interest</b></p></button>

        </div>);
    }
}

export default IRSInterestDetails;


